import { render, staticRenderFns } from "./EdenPricingCalculator.vue?vue&type=template&id=c54b863a&scoped=true"
import script from "./EdenPricingCalculator.vue?vue&type=script&lang=js"
export * from "./EdenPricingCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54b863a",
  null
  
)

export default component.exports